<div
   class="k-form-field k-form-field-with-icon sam-margin-right grid-input-revert-padding-top-bottom"
   (mouseenter)="isMouseOverComponent = true"
   (mouseleave)="isMouseOverComponent = false"
>
   <input
      kendoTextBox
      style="background-color: transparent"
      (debouncedInput)="memoUpdated($event.target.value)"
      [value]="memo"
   />

   <fa-icon
      *ngIf="memo?.length > 0 && isMouseOverComponent"
      class="clear-search-text-icon"
      [icon]="clearFilterIcon"
      (click)="memoUpdated('')"
   >
   </fa-icon>
</div>
